import React from 'react';
import {Navigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import setGlobalState from './redux/setGlobalState';

function ProtectedRoute({children}) {
    // const navigate = useNavigate();
    const isAuthenticated = useSelector(s=>s.auth.isLoggedIn);
    const notAuthenticated = () =>{
        setGlobalState('ui.login.isPrevPath',true);
        // navigate(path);
    };
    return (
        <>
            {isAuthenticated ? children
                : <>
                    {notAuthenticated()}
                    <Navigate to="/login" replace />
                </>}
        </>
    );
}

export default ProtectedRoute;
